import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from '../forms';
import SaveButton from './save-button';
import Takeover from '../takeover';
import './report-sheet.scss';

const Columns = props => {
    const hasChildColumns = props.columns.filter(col => col.childColumns && col.childColumns.length > 0);
    const childColumns = props.columns.map(col => col.childColumns);
   
    if (hasChildColumns && hasChildColumns.length > 0) {
        return (
            <>
                <tr>
                    <th></th>
                    {props.columns.map((col, i) => {
                        return (
                            <th key={col.Id} colSpan={childColumns[i].length}>{col.name}</th>
                        );
                    })}
                </tr>
                <tr>
                    <th></th>
                    {childColumns.map(col => {
                        return col.map(childCol => <th key={childCol.Id}>{childCol.name}</th>);                 
                    })}
                </tr>
            </>
        );
    }
    
    return (
        <tr>
            <th></th>
            {props.columns.map(col => <th key={col.id}>{col.name}</th>)}
        </tr>
    );
};

const RowColumn = data => {
    if (data.columnValueType === 'Summary') {
        return (
            <td>{data.sumX(data.x, data.sumFrom, data.y)}</td>
        );
    }

    const previousValue = data.previousYearValue && `Inrapporterat värde motsvarande period föregående år: ${data.formatValue(data.previousYearValue)}`;
    const warningMsg = data.warning && `Kontrollera det inmatade värdet. Det avviker mer än ${data.indexR12}% från värden rapportrade det senaste året. Inrapporterat värde motsvarande period föregående år: ${data.formatValue(data.previousYearValue)}.`;


    return (
        <td className={classNames({
            'report-sheet__field--warning': data.warning
        })}><input type="text" title={warningMsg ? warningMsg : previousValue} onChange={(e) => data.updateData(e, data)} value={data.valueFormatted} /></td>
    );
};

const Row = row => {
    if (row.rowType === 'FooterSummary') {
        return (
            <tr className="report-sheet__table-summary">
                <th>{row.name}</th>
                {row.columns.map((data, i) => {
                    return (
                        <td key={`${data.productGroupId}${data.reportValueId}${data.unitId}${i}`}><div className="report-sheet__table-summary-sum">{row.sumColumn(i)}</div></td>
                    );
                })}
            </tr>
        );
    }
    
    if (row.rowType === 'Category') {
        return (
            <tr className="report-sheet__table-summary report-sheet__table-summary--category">
                <th>{row.name}</th>
                {row.columns.map((data, i) => {
                    return <td key={`sumcol${i}`}><div className="report-sheet__table-summary-sum">{row.sumCategory(i, row.category.id)}</div></td>;
                })}
            </tr>
        );
    }

    if (row.rowType === 'MerchandiseGroup') {
        return (
            <tr className="report-sheet__table-summary report-sheet__table-summary--merchandise">
                <th>{row.name}</th>
                {row.columns.map((data, i) => {
                    return <td key={`sumcol${i}`}><div className="report-sheet__table-summary-sum">{row.sumMerchandise(i, row.merchandiseGroup.id)}</div></td>;
                })}
            </tr>
        );
    }


    let sumFromX = 0;    
    return (
        <tr>
            <th>{row.name}</th>
            {row.columns.map((data, i) => {
                row.hasWarnings(data.warning);
                const rowCol = <RowColumn key={`rowcolumn${i}`} {...data} {...row} y={i} sumFrom={sumFromX} valueFormatted={row.formatValue(data.value)} />;
                
                if (data.columnValueType === 'Summary') {
                    sumFromX = i;
                }

                return rowCol;
            })}
        </tr>
    );
};

const ReportSheet = props => {
    const [isTakeover, toggleTakeover] = useState(false);

    return (
        <>
            <section className={classNames({
                'report-sheet': true,
                'report-sheet--is-loading': props.isLoading || props.isSaving || props.isUploading,
            })}>
                <div className="report-sheet__wrapper">
                    <div className="report-sheet__content">
                        <header className="report-sheet__controls">
                            <ul className="report-sheet__import">
                                <li className="report-sheet__heading"><strong>Läs in från fil</strong> (xlsx)</li>
                                <li>
                                    <label className="report-sheet__upload">
                                        <input type="file" 
                                               onChange={props.uploadFile} 
                                               accept=".xlsx, .xls" />
                                        {!props.isUploading && 
                                            <span>Bläddra…</span>
                                        }
                                        {props.isUploading &&
                                            <span className="spinner-bounce spinner-bounce--black">
                                                <span className="bounce1"></span>
                                                <span className="bounce2"></span>
                                                <span className="bounce3"></span>
                                            </span>
                                        }
                                    </label>
                                </li>
                                {props.additionalInfo && props.additionalInfo.inDataFileUrl &&
                                    <li>
                                        <a href={props.additionalInfo.inDataFileUrl} target="_blank" rel="noreferrer">Indatamall</a>
                                    </li>
                                }
                                {props.additionalInfo && props.additionalInfo.definition &&
                                    <li>
                                        <button type="button" onClick={(e) => {
                                            e.preventDefault(); toggleTakeover(true);
                                        }}>Definitioner</button>
                                    </li>
                                }
                            </ul>

                            <ul className="report-sheet__sheet-controls">
                                <li><button className="report-sheet__clear" type="button" onClick={props.resetTable}>Rensa</button></li>
                            </ul>

                            {props.fileName &&
                                <div className="report-sheet__selected-file">
                                    <div className="report-sheet__selected-file-inner">
                                        <strong>Vald fil:</strong> {props.fileName}
                                    </div>
                                </div>
                            }
                            
                            {props.isUploadError &&
                                <div className="report-sheet__upload-error">
                                    <div className="report-sheet__upload-error-inner">
                                        Något gick snett vid inläsning av excelfilen. Vänligen kontrollera filen och ladda upp den igen.
                                    </div>
                                </div>
                            }
                        </header>

                        <div className="report-sheet__table-wrapper">
                            <table className="report-sheet__table">
                                <thead>
                                    <Columns columns={props.data.columns} />
                                </thead>
                                <tbody>
                                    {props.data.rows.map((row, i) => <Row key={`row${i}`} {...row} 
                                                                        x={i} 
                                                                        updateData={props.updateData} 
                                                                        formatValue={props.formatValue}
                                                                        sumX={props.sumX} 
                                                                        sumCategory={props.sumCategory}
                                                                        sumMerchandise={props.sumMerchandise} 
                                                                        sumColumn={props.sumColumn} 
                                                                        hasWarnings={props.hasWarnings} /> )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <div className="report-sheet__footer">
                <div className="report-sheet__footer-inner">
                    <div className="report-sheet__footer-content">
                        
                        <div className={classNames({
                            'report-sheet__warning': true,
                            'report-sheet__warning--is-warning': props.isWarning
                        })}>
                            <div className="report-sheet__warning-inner">
                                Värdena har sparats men det fanns varningar. Var god dubbelkolla dessa och korrigera vid behov.
                            </div>
                        </div>
                        <a href={props.companyUrl} className="report-sheet__back" rel="noreferrer">Avbryt</a>
                        <SaveButton onClick={props.save} 
                                    isLoading={props.isSaving} 
                                    isSaved={props.isSaved} 
                                    text="Spara rapporten"
                                    textSaving="Sparar rapporten"
                                    textSaved="Rapporten sparades!" />
                    </div>
                </div>
            </div>
            <Takeover isOpen={isTakeover} toggleTakeover={() => toggleTakeover(false)} heading="Definitioner">
                {props.additionalInfo &&
                    <>
                        <p>{props.additionalInfo.definition}</p>
                        <p>
                            <a href={props.additionalInfo.definitionFileUrl} target="_blank" rel="noreferrer">Ladda hem definitioner</a>
                        </p>
                        {props.additionalInfo.companies &&
                            <>
                                <h2>Företag i gren ({props.additionalInfo.companies.length})</h2>
                                <ul>
                                {props.additionalInfo.companies.map(company => {
                                    return <li key={company.id}>{company.name}</li>
                                })}                                 
                                </ul>
                            </>
                        }
                        <div className="statstics-list__takeover-footer">
                            <Button type="button" 
                                    modifiers={{
                                        'form__button--muted': true,
                                        'form__button--centered': true
                                    }}
                                    onClick={() => toggleTakeover(!isTakeover)}>Stäng</Button>
                        </div>
                    </>
                }
            </Takeover>
        </>
    );
};

export default ReportSheet;